<template>
    <div data-component="AmsPriceIndicatorModalTags">
        <div class="p-16 border rounded-10 solid border-color-neutral-grey-10">
            <ams-rating-lights :priceClass="item.priceIndicator.priceClass" hasText />
            <div v-if="hasRating" class="flex flex-wrap gap-8 mt-16">
                <span
                    v-for="(tag, i) in tags"
                    :key="tag"
                    :class="{ 'flex gap-4 after:h-full after:w-1 after:bg-color-neutral-grey-10': i <= 2 }"
                >
                    <cs-tag>{{ tag }}</cs-tag>
                    <span v-if="i === 0" class="text-h4">verglichene Gebrauchtwagen</span>
                </span>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { commonUtils } from '@sunrise/shared'
import { PropType } from 'vue'
import { AmsItem } from '../../../services/amsSearch/amsSearch.interface'
import { CsTag } from '@sunrise/components'
import AmsRatingLights from '../AmsRatingLights/AmsRatingLights.vue'

const props = defineProps({
    item: {
        type: Object as PropType<AmsItem>,
        required: true,
    },
    hasRating: Boolean,
})

const tags = [
    commonUtils.thousandSeparator(props.item.priceIndicator.comparedVehicleCount),
    props.item.make,
    props.item.model,
    props.item.initialRegistrationDate,
]
</script>
